import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'

const couponRouter: Array<RouteRecordRaw> = [
    {
        path: '/coupon',
        name: '卡券管理',
        component: Layout,
        redirect: '/coupon/package-list',
        meta: { title: '卡券管理', icon: 'icon-card', alwaysShow: true },
        children: [
            {
                path: 'package-list',
                name: '卡券生成列表',
                component: () => import('@/views/coupon/PackageList.vue'),
                meta: { title: '卡生成列表', keepAlive: true, depth: 30 }
            },
            {
                path: 'package-edit',
                name: '卡券包编辑',
                component: () => import('@/views/coupon/PackageEdit.vue'),
                meta: { title: '卡券包编辑', hidden: true }
            },
            {
                path: 'coupon-list',
                name: '卡券列表',
                component: () => import('@/views/coupon/CouponList.vue'),
                meta: { title: '卡券列表' }
            },
            {
                path: 'expired-list',
                name: '过期卡券列表',
                component: () => import('@/views/coupon/ExpiredList.vue'),
                meta: { title: '过期卡券列表' }
            },
            {
                path: 'active-list',
                name: '卡券激活列表',
                component: () => import('@/views/coupon/CouponList.vue'),
                meta: { title: '卡券激活列表' }
            },
            {
                path: 'cancel-list',
                name: '卡券作废列表',
                component: () => import('@/views/coupon/CouponList.vue'),
                meta: { title: '卡券作废列表' }
            },
            {
                path: 'sale-list',
                name: '卡券销售列表',
                component: () => import('@/views/coupon/CouponList.vue'),
                meta: { title: '卡券销售列表', keepAlive: true, depth: 30 }
            },
            {
                path: 'close-card-list',
                name: '关卡记录',
                component: () => import('@/views/coupon/CloseCardList.vue'),
                meta: { title: '关卡记录', keepAlive: true, depth: 30 }
            },
            {
                path: 'sale-log',
                name: '卡券销售记录',
                component: () => import('@/views/coupon/CouponList.vue'),
                meta: { title: '卡券销售记录', keepAlive: true, depth: 30 }
            },
            {
                path: 'statistics-list',
                name: '卡券统计列表',
                component: () => import('@/views/coupon/StatisticsList.vue'),
                meta: { title: '卡券统计列表', keepAlive: true, depth: 30 }
            },
            {
                path: 'consume-list',
                name: '卡券消费记录',
                component: () => import('@/views/coupon/ConsumeList.vue'),
                meta: { title: '卡券消费记录', keepAlive: true, depth: 30}
            },
            {
                path: 'logs',
                name: '卡券历史记录',
                component: () => import('@/views/coupon/Logs.vue'),
                meta: { title: '卡券历史记录', keepAlive: true, depth: 30 }
            },
            {
                path: 'bind',
                name: '卡券绑定',
                component: () => import('@/views/coupon/Bind.vue'),
                meta: { title: '卡券绑定' }
            },
            {
                path: 'huafa-list',
                name: '开卡申请管理',
                component: () => import('@/views/coupon/HuafaList.vue'),
                meta: { title: '开卡申请管理', keepAlive: true, depth: 30 }
            },
            {
                path: 'coupon-search',
                name: '卡券查询',
                component: () => import('@/views/coupon/CouponSearch.vue'),
                meta: { title: '卡券查询' }
            },
            {
                path: 'taste-search',
                name: '川之味查券',
                component: () => import('@/views/coupon/TasteSearch.vue'),
                meta: { title: '川之味查券' }
            },
            {
                path: 'edit-log',
                name: '修改记录',
                component: () => import('@/views/coupon/EditLog.vue'),
                meta: { title: '修改记录' }
            },
            {
                path: 'movie-log',
                name: '电影院门店',
                component: () => import('@/views/coupon/MovieLog.vue'),
                meta: { title: '电影院门店' }
            },
            {
                path: 'export-brand',
                name: '品牌城市导出',
                component: () => import('@/views/coupon/CityExport.vue'),
                meta: { title: '品牌城市导出' }
            },
            {
                path: 'nation-check',
                name: '国能充值审核',
                component: () => import('@/views/coupon/NationList.vue'),
                meta: { title: '国能充值审核' }
            },
            {
                path: 'nation-check-detail',
                name: '国能充值审核详情',
                component: () => import('@/views/coupon/NationCheck.vue'),
                meta: { title: '国能充值审核详情' }
            },
            {
                path: 'bind-coupon',
                name: '发码申请',
                component: () => import('@/views/channel/BindCoupon.vue'),
                meta: { title: '绑卡与发码' }
            },
        ]
    }
]

export default couponRouter